// The single home for Vite's `import.meta.env`. ts-jest emits CommonJS, where `import.meta`
// is a parse-time SyntaxError — so any module that touches it directly becomes untestable,
// and so does everything that transitively imports it. Jest swaps this module for
// `vite-env.jest.util.ts` via moduleNameMapper (see jest.config.js); Vite uses this real one.
// Never read `import.meta.env` directly from modules unit tests may reach — import `viteEnv`.
export const viteEnv = import.meta.env;
